/* @flow */

import PivotByTimeAction from "../actions/PivotByTimeAction";

import type {
    ClickAction,
    ClickActionProps
} from "platopulse/meta/types/Visualization";

export default (props: ClickActionProps): ClickAction[] => {
    return PivotByTimeAction(props);
};



// WEBPACK FOOTER //
// ./qb/components/drill/PivotByTimeDrill.jsx